var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDjlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 278,
    viewBox: "0 0 243 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.857 69.5H0V208.5H138.857V69.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.857 0H69.4286V208.5H138.857V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 0H173.571V69.5H243V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 139H173.571V278H243V139Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 278,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjlogo);
export default __webpack_public_path__ + "static/media/djlogo.b3b873fa8b9659d8284cf57820ba476a.svg";
export { ForwardRef as ReactComponent };